/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RecoverPasswordRequest } from '@app/core/models/auth/recover-password-request';
import { ErrorResponse } from '@app/core/models/commom/error-response';
import { AuthApiService } from '@app/core/services/api/auth-api.service';
import { VaultBaseComponent } from '@app/shared/components/base/vault-base.component';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import { IdValue } from '@interfaces/a-organizar/idValue';
import { TranslateService } from '@ngx-translate/core';
import { FormErrorHandlerService } from '@services/helpers/form-error-handler.service';
import { ToastHelperService } from '@services/helpers/toast-helper.service';
import { UtilsService } from '@services/helpers/utils.service';
import { nameof } from '@src/app/core/utils/nameof.utils';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-first-access-form',
  templateUrl: './first-access-form.component.html',
  styleUrls: ['./first-access-form.component.scss'],
  standalone: false,
})
export class FirstAccessFormComponent extends VaultBaseComponent {
  @Output() sendFormModeChange = new EventEmitter<string>();

  faArrowLeftLong = faArrowLeftLong;

  props = nameof<RecoverPasswordRequest>();

  firstAccessForm: FormGroup = this.formBuilder.group({
    [this.props.email]: ['', [Validators.required, Validators.email]],
  });

  constructor(
    private formBuilder: FormBuilder,
    private utilService: UtilsService,
    private authApiService: AuthApiService,
    private formErrorHandler: FormErrorHandlerService,
    private toast: ToastHelperService,
    translateService: TranslateService
  ) {
    super(translateService);
  }

  handleFormMode(formMode: string) {
    this.sendFormModeChange.emit(formMode);
  }

  handleFormValue(formValue: IdValue) {
    if (!formValue.id) return;
    const controlName = formValue.id as string;
    this.firstAccessForm.get(controlName)?.setValue(formValue.value);
  }

  isEmailInvalidOrEmpty(): boolean {
    return this.utilService.isControlInvalidOrEmpty(this.firstAccessForm, 'email');
  }

  async onSubmit() {
    try {
      this.isLoading = true;
      const recoverPasswordRequest = this.firstAccessForm.value as RecoverPasswordRequest;
      await lastValueFrom(this.authApiService.recoverPassword(recoverPasswordRequest));

      this.toast.showToastSuccess(
        this.t(this.tk.Auth.RecoverPasswordTitle),
        this.t(this.tk.Auth.RecoverPasswordSuccess)
      );

      this.handleFormMode('login');
    } catch (error) {
      if (error instanceof ErrorResponse) {
        this.formErrorHandler.applyFormErrors(this.firstAccessForm, error);
      } else {
        console.error(error);
      }
    } finally {
      this.isLoading = false;
    }
  }
}
